import { kfzInputClientEntityDehydrationDefinitions } from '@/features/Sparten/shared/clientDehydration/kfz/conditionalClientRequestDefinitions';
import type { ConditionalRequestDefinition } from '@/utils/dehydrateRequestData/types';
import { computed } from 'vue';
import { KfzFahrerResource } from '@/features/Sparten/shared/schema/kfz/clientSchema/clientSchema';

const nonAvailableFields: ConditionalRequestDefinition = {
  if: computed(() => true),
  drop: [
    'meta.hasAnBegleitetenFahrenTeilgenommen',
    'meta.hasAnSicherheitstrainingTeilgenommen',
    'meta.hasPunkteInFlensburg',
    'meta.hasJahreskarteOeffentlicherPersonenverkehr',
    'meta.jahreskarteOeffentlicherPersonenverkehr',
    'meta.hasWohneigentum',
    'meta.wohneigentum',
  ],
};

export const clientInputDehydration: ConditionalRequestDefinition<KfzFahrerResource>[] =
  [...kfzInputClientEntityDehydrationDefinitions, nonAvailableFields];
